// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AuthActions } from '../../auth/duck';
import type { RootState } from '../../index';
import SignUpPage from '../components/SignUp/SignUpPage';

function mapStateToProps(state: RootState) {
  return {
    isAuthing: state.auth.isAuthing,
    isRegistering: state.auth.isRegistering,
    signUpError: state.auth.signUpError,
    authError: state.auth.authError,
    authenticated: state.auth.authenticated,
    registerSuccessState: state.auth.registerSuccessState,
    user: state.auth.user,
    locale: state.locale,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(AuthActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage);



// WEBPACK FOOTER //
// ./src/modules/auth/containers/SignUpContainer.js